module.exports = __webpack_public_path__ + "static/modifyButton-c1c485a3b4c6780e9525785742d0df86.png";